module.exports = __webpack_public_path__ + "img/iripple-logo-primary.d56bd780.png";